export default class OnScreenDebugger {
  private static _instance: OnScreenDebugger;
  public static get instance(): OnScreenDebugger {
    return this._instance ?? new OnScreenDebugger();
  }

  private _enabled: boolean = false;

  private readonly _targetElement: HTMLElement;
  private _logContainer: HTMLDivElement;
  private _logContainerInner: HTMLDivElement;

  constructor() {
    if (OnScreenDebugger._instance) {
      throw new Error('OnScreenDebugger can only be used as a singleton, use OnScreenDebugger.Instance instead');
    }

    this._targetElement = document.body;
    this._logContainer = document.createElement('div');

    this._logContainer.style.display = this._enabled ? null : 'none';

    this._logContainer.style.position = 'fixed';
    this._logContainer.style.top = '0px';
    this._logContainer.style.width = '50%';
    this._logContainer.style.height = '100vh';
    this._logContainer.style.right = '0px';
    this._logContainer.style.zIndex = '999999';
    this._logContainer.style.backgroundColor = 'black';
    this._logContainer.style.padding = '20px';
    this._logContainer.style.opacity = '.7';
    this._logContainer.style.overflowY = 'scroll';
    this._logContainer.style.overflowX = 'hidden';

    this._targetElement.append(this._logContainer);

    this._logContainerInner = document.createElement('div');
    this._logContainerInner.style.color = 'white';
    this._logContainerInner.style.fontFamily = 'arial';
    this._logContainerInner.style.fontSize = '12px';
    this._logContainerInner.style.width = '100%';
    this._logContainerInner.style.height = 'auto';
    this._logContainer.append(this._logContainerInner);

    OnScreenDebugger._instance = this;
  }

  private print(info: string) {
    const log = document.createElement('div');
    log.innerHTML = info;
    this._logContainerInner.append(log);
  }

  public log(info: string) {
    if (this._enabled) {
      this.print(info);
    }
  }
}
